module.exports = __webpack_public_path__ + "img/ls_img4.08bea477.png";